import type { Service } from '../types/content'

export const services: Service[] = [
  {
    id: 'atraccion-del-amor',
    title: 'Atracción del Amor',
    description:
      'Trabajos y amarres de la brujería tradicional en el terreno sentimental y de pareja.',
    points: [
      'Si estás atravesando una situación sentimental complicada.',
      'Si una relación se ha distanciado.',
      'Si deseas orientación sobre una relación.',
      'Si estás atravesando cambios en tu vida sentimental.',
      'Si buscas una consulta personalizada sobre el amor.',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/opQAaw66P5adnx33DHyqW7/image.png',
    imageAlt: 'Dos personas tomadas de la mano al aire libre',
  },
  {
    id: 'alejamientos-y-separaciones',
    title: 'Alejamientos y Separaciones',
    description:
      'Prácticas espirituales tradicionales para situaciones personales y vínculos interpersonales conflictivos.',
    points: [
      'Orientación espiritual ante relaciones difíciles.',
      'Consultas por cambios y conflictos interpersonales.',
      'Rituales y trabajos de la tradición.',
      'Atención personalizada y reservada.',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/1LWx9FUdckQ26n3eomn7hK/image.png',
    imageAlt: 'Pareja sentada en una mesa durante una conversación difícil',
  },
  {
    id: 'amarres-del-mismo-sexo',
    title: 'Amarres del Mismo Sexo',
    description:
      'Amarres y trabajos espirituales tradicionales en el ámbito sentimental, con la misma seriedad y discreción.',
    points: [
      'Consultas sobre relaciones y vínculos personales.',
      'Orientación espiritual ante situaciones afectivas.',
      'Trabajos de la brujería tradicional.',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/m37pgVX4U3BCRvyCdf7Nd2/image.png',
    imageAlt: 'Pareja del mismo sexo abrazándose con cercanía',
  },
  {
    id: 'pactos-y-rituales',
    title: 'Pactos y Rituales Espirituales',
    description:
      'Pactos y rituales espirituales de la tradición, preparados según las necesidades, circunstancias y creencias de cada persona.',
    points: [
      'Pactos y rituales de la práctica tradicional.',
      'Consultas privadas y personalizadas.',
      'Orientación en torno a objetivos personales y espirituales.',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/2AYrVRo4wQRDDeqUnmReXL/image.png',
    imageAlt: 'Ritual con una vela encendida y manos sobre un altar en penumbra',
  },
  {
    id: 'practicas-y-tradiciones',
    title: 'Prácticas y Tradiciones Espirituales',
    description:
      'Las escuelas y tradiciones que sostienen nuestro trabajo, aplicadas con el criterio que cada caso requiere.',
    points: [
      'Brujería tradicional.',
      'Prácticas Vudú.',
      'Tradiciones Santeras.',
      'Prácticas Chamánicas.',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/ufo57CiefKUqcDX9wnMkYt/image.png',
    imageAlt:
      'Carta de tarot, cuarzo y elementos rituales rodeados por un círculo de velas encendidas',
  },
  {
    id: 'proteccion-y-contrabrujeria',
    title: 'Protección y Contrabrujería',
    description:
      'Trabajos de protección y contrabrujería para quienes atribuyen su situación a energías negativas o influencias espirituales.',
    points: [
      'Orientación espiritual ante situaciones difíciles.',
      'Rituales tradicionales de protección.',
      'Consultas sobre energías negativas y contrabrujería.',
      'Acompañamiento personalizado.',
    ],
    image: 'https://cdn.magicpatterns.com/uploads/s6rnD4AafTC49dmn5Zcz33/image.png',
    imageAlt:
      'Libro ritual abierto con símbolos, velas encendidas, espejo antiguo y amuletos de protección',
  },
]
